import React from "react";
import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const ReviewEmpty = ({ fill, ...props }) => (
    <SVG fill="none" {...props}>
        <path
            d="M7.00008 14.0005c2.10239 0 3.80672-1.705 3.80672-3.8083 0-2.10323-1.70433-3.80826-3.80672-3.80826-2.1024 0-3.80673 1.70503-3.80673 3.80826 0 2.1033 1.70433 3.8083 3.80673 3.8083Z"
            fill={fill}
        />
        <path
            d="M3.45642 7.59119c.74401-.63751.69095-1.92077-.11852-2.86625-.80947-.94548-2.06882-1.19514-2.81283-.55763-.74401.6375-.69095 1.92076.11852 2.86624.80947.94548 2.06882 1.19514 2.81283.55764Z"
            fill={fill}
        />
        <path
            d="M13.3566 7.03421c.8095-.94548.8625-2.22874.1185-2.86624-.744-.63751-2.0033-.38785-2.8128.55763-.80948.94548-.86255 2.22874-.1185 2.86625.744.6375 2.0033.38784 2.8128-.55764Z"
            fill={fill}
        />
        <path
            d="M5.49985 4.56396c.91849-.24037 1.39836-1.44752 1.07183-2.69624C6.24515.61899 5.23586-.19844 4.31738.04194 3.3989.2823 2.91902 1.48945 3.24556 2.73818c.32653 1.24873 1.33581 2.06616 2.25429 1.82578Z"
            fill={fill}
        />
        <path
            d="M10.7552 2.7388c.3265-1.24872-.1533-2.45587-1.07181-2.69625-.91848-.24037-1.92776.57706-2.2543 1.82578-.32653 1.24873.15334 2.45588 1.07183 2.69625.91848.24037 1.92778-.57706 2.25428-1.82578Z"
            fill={fill}
        />
    </SVG>
);

ReviewEmpty.propTypes = {
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    fill: PropTypes.string,
};

ReviewEmpty.defaultProps = {
    height: "14px",
    viewBox: "0 0 14 14",
    width: "14px",
    fill: "#A0B7B4",
};

export default ReviewEmpty;
